import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

export function SaveQuoteModal({ open, onOpenChange, form, onFormChange, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-[#6A7359]">Save Quote</DialogTitle>
          <DialogDescription>Save your quote to retrieve later.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-3">
          <Input 
            placeholder="Your Name (optional)" 
            value={form.name} 
            onChange={(e) => onFormChange("name", e.target.value)} 
            data-testid="save-name" 
          />
          <Input 
            placeholder="Email (optional)" 
            type="email" 
            value={form.email} 
            onChange={(e) => onFormChange("email", e.target.value)} 
            data-testid="save-email" 
          />
          <div className="flex gap-2 pt-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">
              Cancel
            </Button>
            <Button 
              onClick={onSubmit} 
              className="flex-1 bg-[#6A7359] hover:bg-[#565E48]" 
              data-testid="save-quote-submit-btn"
            >
              Save Quote
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
